import React, { useState, Fragment, useContext } from 'react';
import JumboContentLayout from '@jumbo/components/JumboContentLayout';
import useJumboTheme from '@jumbo/hooks/useJumboTheme';
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Form, Formik } from 'formik';
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';
import JumboSelectField from '@jumbo/components/JumboFormik/JumboSelectField';
import { ApiService } from 'app/servicesTwo/ApiService';
import { useLocation } from 'react-router-dom';
import { updateInputValue } from '../../../utils/appHelpers';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { PermissionContext } from 'app/contexts/PermissionContext';

const ModalChangeStatus = ({
  data,
  handleClose,
  classStudents,
  setClassStudents,
}) => {
  const { theme } = useJumboTheme();
  const location = useLocation();
  const lg = useMediaQuery(theme.breakpoints.down('lg'));
  const layoutOptions = React.useMemo(
    () => ({
      sidebar: {
        sx: {
          [theme.breakpoints.up('lg')]: {
            position: 'sticky',
            zIndex: 5,
            top: 96,
            minHeight: 'auto',
          },
          [theme.breakpoints.down('lg')]: {
            display: 'none',
          },
        },
      },
      wrapper: {
        sx: {
          alignItems: 'flex-start',
        },
      },
    }),
    [theme]
  );

  const initialValues = {
    status: data.status ?? null,
    observacao: data.observacao ?? null,
    motivo_reprovacao: data.motivo_reprovacao ?? null,
    ano_de_conclusao: data.ano_de_conclusao ?? null,
    motivo_exclusao: data.motivo_exclusao ?? null,
    outro_motivo_exclusao: data.outro_motivo_exclusao ?? null,
  };

  console.log(data);
  const Swal = useSwalWrapper();
  const toast = (variant, message) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: variant,
      title: message,
      showCloseButton: true, // botão de fechar
      closeButtonAriaLabel: 'Fechar',
    });
  };

  const [classData, setClassData] = useState([]);

  const { hasPermission } = useContext(PermissionContext);

  const motivosExclusao = [
    'Discorda do método de ensino',
    'Excesso de tarefas',
    'Excedeu o limite de faltas',
    'Mudança de residência',
    'Não estava gostando do curso',
    'Não realizou tarefas',
    'Outros motivos',
    'Problemas com a equipe de Ensino',
    'Problemas de saúde',
    'Problemas de saúde com familiar',
    'Problemas financeiros',
  ];

  function updateById(arr, id, data) {
    const objIndex = arr.findIndex((obj) => obj.curso_historico_id === id);

    arr[objIndex].status = data.status;
    arr[objIndex].observacao = data.observacao;
    arr[objIndex].motivo_reprovacao = data.motivo_reprovacao;
    arr[objIndex].motivo_exclusao = data.motivo_exclusao;
    arr[objIndex].outro_motivo_exclusao = data.outro_motivo_exclusao;

    return arr;
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    const curso_historico_id = data.curso_historico_id;

    console.log({ values });

    // clona os valores para não alterar diretamente o objeto
    const cleanedValues = { ...values };

    // Se o status não for 'Excluído', limpa motivos de exclusão
    /*   if (cleanedValues.status !== 'Excluído') {
      cleanedValues.motivo_exclusao = '';
      cleanedValues.outro_motivo_exclusao = '';
    } else {
      // Se o motivo de exclusão não for 'Outro', limpa o campo de outro motivo
      if (cleanedValues.motivo_exclusao !== 'Outros motivos') {
        cleanedValues.outro_motivo_exclusao = '';
      }
    } */


    // Se está reprovando e o curso é Aprendizes do Evangelho
    if (
      cleanedValues.status === 'Reprovado' && 
      data.nome_curso?.includes('Aprendizes do Evangelho')
    ) {
      // Mostrar confirmação ao operador
      const result = await Swal.fire({
        title: 'Atenção!',
        html: `
          <p>Ao reprovar o aluno <strong>${data.nome}</strong> no curso <strong>Aprendizes do Evangelho</strong>,
          o sistema verificará se ele também está cursando <strong>Educação Mediúnica</strong>.</p>
          <p>Caso esteja, ele será <strong>reprovado automaticamente</strong> neste curso também.</p>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      });

      if (!result.isConfirmed) {
        setSubmitting(false);
        return;
      }
    }

    ApiService.put(`/turmas/atualizar-status/${curso_historico_id}`, {
      values: cleanedValues,
    })
      .then((response) => {
        const newArr = updateById(
          classStudents,
          curso_historico_id,
          cleanedValues
        );
        setClassStudents(newArr);

        if (response.data.reprovacaoCascata) {
          const { curso, turma } = response.data.reprovacaoCascata;
          
          Swal.fire({
            title: 'Status atualizado!',
            html: `
              <p>✅ Aluno reprovado em <strong>Aprendizes do Evangelho</strong></p>
              <p>⚠️ Aluno também foi reprovado em <strong>${curso}</strong></p>
            `,
            icon: 'success',
            confirmButtonText: 'Ok, entendi'
          });
        } else {
          toast('success', 'Status atualizado com sucesso');
        }

        //toast('success', 'Status atualizado com sucesso');
        handleClose();
      })
      .catch((error) => {
        toast('error', 'Ocorreu um erro');

        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('error', error.message);
        }
      });
  };

  return (
    <JumboContentLayout layoutOptions={layoutOptions}>
      {lg && (
        <Stack spacing={2} direction={'row'} sx={{ mb: 3, mt: -2 }}></Stack>
      )}
      <Paper sx={{ p: '40px' }}>
        <Box
          display='flex'
          justifyContent='flex-end'
          alignItems='center'
          marginRight='1rem'
        >
          <Button size='small' variant='contained' onClick={handleClose}>
            Fechar
          </Button>
        </Box>
        <Typography
          variant={'h1'}
          style={{ textAlign: 'center', marginBottom: 30 }}
        >
          Atualização de Status
        </Typography>
        <Fragment>
          <Formik
            initialValues={initialValues}
            // validationSchema={validationSchema}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={handleSubmit}
          >
            {({ values, isSubmitting, handleChange }) => (
              <Form style={{ width: '100%' }} noValidate autoComplete='off'>
                <Grid container spacing={3} alignContent={'center'}>
                  <Grid item xs={12}>
                    <Box display={'flex'} gap={1} alignItems={'center'}>
                      <Typography variant='h4' fontWeight={'300'}>
                        Aluno selecionado:
                      </Typography>

                      <Typography
                        variant='h4'
                        textTransform={'capitalize'}
                        fontWeight={'bold'}
                      >
                        {data?.nome}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id='status'>Status</InputLabel>
                      <JumboSelectField
                        labelId='status'
                        id='status'
                        name='status'
                        value={updateInputValue(classData, values, 'status')}
                        label='Status'
                        disabled={
                          location?.pathname.includes('edit')
                            ? true
                            : !hasPermission(
                                'Atualizar Status ou Transferir Aluno',
                                'editar'
                              ) &&
                              !hasPermission(
                                'Inclusão de Alunos na Turma',
                                'editar'
                              )
                        }
                      >
                        {/* <MenuItem value={'Aprovado'}>Aprovado</MenuItem> */}
                        <MenuItem value={'Reprovado'}>Reprovado</MenuItem>
                        {/*  <MenuItem value={'Ativo'}>Ativo</MenuItem> */}
                        <MenuItem value={'Desistente'}>Desistente</MenuItem>
                        <MenuItem value={'Excluído'}>Excluído</MenuItem>
                        <MenuItem value={'Outro'}>Outro</MenuItem>
                      </JumboSelectField>
                    </FormControl>
                  </Grid>
                  {/* {values.status == 'Reprovado' && (
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <JumboTextField
                          fullWidth
                          name='motivo_reprovacao'
                          label='Motivo de reprovação'
                          multiline
                          rows={4}
                          value={updateInputValue(
                            classData,
                            values,
                            'motivo_reprovacao'
                          )}
                          disabled={
                            location?.pathname.includes('edit')
                              ? true
                              : !hasPermission(
                                  'Atualizar Status ou Transferir Aluno',
                                  'editar'
                                ) &&
                                !hasPermission(
                                  'Inclusão de Alunos na Turma',
                                  'editar'
                                )
                          }
                          sx={{ background: '#ffffff' }}
                        />
                      </FormControl>
                    </Grid>
                  )} */}
                  {/* {values.status == 'Aprovado' && 
                                    <Grid item xs={12} >
                                        <FormControl fullWidth>
                                            <JumboTextField
                                                fullWidth
                                                name="ano_de_conclusao"
                                                label="Ano de conclusão"
                                                value={updateInputValue(classData, values, 'ano_de_conclusao')}
                                                disabled={ location?.pathname.includes('edit') ? true : !hasPermission('Inclusão de Alunos na Turma', 'editar')}
                                                sx={{ background: '#ffffff'}}
                                            />
                                        </FormControl>
                                    </Grid>
                                } */}
                  {/*  {values.status === 'Excluído' && (
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id='motivo_exclusao'>
                          Motivo da exclusão
                        </InputLabel>
                        <JumboSelectField
                          labelId='motivo_exclusao'
                          id='motivo_exclusao'
                          name='motivo_exclusao'
                          label='Motivo da exclusão'
                          value={updateInputValue(
                            classData,
                            values,
                            'motivo_exclusao'
                          )}
                          disabled={
                            location?.pathname.includes('edit')
                              ? true
                              : !hasPermission(
                                  'Atualizar Status ou Transferir Aluno',
                                  'editar'
                                ) &&
                                !hasPermission(
                                  'Inclusão de Alunos na Turma',
                                  'editar'
                                )
                          }
                        >
                          <MenuItem value={''}>Selecione</MenuItem>
                          {motivosExclusao.map((motivo, index) => (
                            <MenuItem key={index} value={motivo}>
                              {motivo}
                            </MenuItem>
                          ))}
                        </JumboSelectField>
                      </FormControl>
                    </Grid>
                  )} */}

                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id='motivo_exclusao'>Motivo</InputLabel>
                      <JumboSelectField
                        labelId='motivo_exclusao'
                        id='motivo_exclusao'
                        name='motivo_exclusao'
                        label='Motivo'
                        value={updateInputValue(
                          classData,
                          values,
                          'motivo_exclusao'
                        )}
                        disabled={
                          location?.pathname.includes('edit')
                            ? true
                            : !hasPermission(
                                'Atualizar Status ou Transferir Aluno',
                                'editar'
                              ) &&
                              !hasPermission(
                                'Inclusão de Alunos na Turma',
                                'editar'
                              )
                        }
                      >
                        <MenuItem value={''}>Selecione</MenuItem>
                        {motivosExclusao.map((motivo, index) => (
                          <MenuItem key={index} value={motivo}>
                            {motivo}
                          </MenuItem>
                        ))}
                      </JumboSelectField>
                    </FormControl>
                  </Grid>

                  {/* {values.status === 'Excluído' &&
                    values.motivo_exclusao === 'Outros motivos' && (
                      <Grid item xs={12}>
                        <FormControl fullWidth>
                          <JumboTextField
                            fullWidth
                            name='outro_motivo_exclusao'
                            label='Informe o motivo'
                            multiline
                            rows={2}
                            value={updateInputValue(
                              classData,
                              values,
                              'outro_motivo_exclusao'
                            )}
                            disabled={
                              location?.pathname.includes('edit')
                                ? true
                                : !hasPermission(
                                    'Atualizar Status ou Transferir Aluno',
                                    'editar'
                                  ) &&
                                  !hasPermission(
                                    'Inclusão de Alunos na Turma',
                                    'editar'
                                  )
                            }
                            sx={{ background: '#ffffff' }}
                          />
                        </FormControl>
                      </Grid>
                  )} */}

                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      {/* <InputLabel id="observacao">Observação</InputLabel> */}
                      <JumboTextField
                        fullWidth
                        name='observacao'
                        label='Observação'
                        multiline
                        rows={4}
                        value={updateInputValue(
                          classData,
                          values,
                          'observacao'
                        )}
                        disabled={
                          location?.pathname.includes('edit')
                            ? true
                            : !hasPermission(
                                'Atualizar Status ou Transferir Aluno',
                                'editar'
                              ) &&
                              !hasPermission(
                                'Inclusão de Alunos na Turma',
                                'editar'
                              )
                        }
                        sx={{ background: '#ffffff' }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <LoadingButton
                      color='success'
                      type='submit'
                      variant='contained'
                      size='large'
                      sx={{ maxWidth: { md: '200px', mt: '1rem' } }}
                      loading={isSubmitting}
                      disabled={
                        location?.pathname.includes('edit')
                          ? true
                          : (!hasPermission(
                              'Atualizar Status ou Transferir Aluno',
                              'editar'
                            ) &&
                              !hasPermission(
                                'Inclusão de Alunos na Turma',
                                'editar'
                              )) ||
                            (values.status === 'Aprovado' &&
                              !values.ano_de_conclusao) /* values.status === 'Excluído' && */ ||
                            /* (values.status === 'Excluído' &&
                              !values.motivo_exclusao) || */
                            !values.motivo_exclusao /* ===
                                'Outros motivos' */ /* &&
                              !values.outro_motivo_exclusao */
                      }
                    >
                      Atualizar
                    </LoadingButton>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Fragment>
      </Paper>
    </JumboContentLayout>
  );
};

export default ModalChangeStatus;
